import * as React from "react";
import { SvgIcon } from "@mui/material";
/**
 * App-wide checkbox faces (wired as MuiCheckbox `defaultProps` in `common/theme.ts`):
 * a soft rounded outline when unchecked and a filled rounded square when checked —
 * MUI's stock glyphs read as bare squares. Real SVGs (not styled spans) so they scale
 * with the Checkbox `size` prop and existing `& svg` overrides (e.g. the data grids'),
 * and inherit checked/disabled coloring via `currentColor`.
 */
export const checkboxBlankIcon = (React.createElement(SvgIcon, { viewBox: "0 0 24 24" },
    React.createElement("rect", { x: "3.6", y: "3.6", width: "16.8", height: "16.8", rx: "4.6", fill: "none", stroke: "currentColor", strokeWidth: "1.2" })));
// MUI's standard check glyph, scaled to sit inside the filled rounded square.
const CHECK_PATH = "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z";
export const checkboxCheckedIcon = (React.createElement(SvgIcon, { viewBox: "0 0 24 24" },
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "5", fill: "currentColor" }),
    React.createElement("path", { d: CHECK_PATH, fill: "#fff", transform: "translate(12 12) scale(0.68) translate(-12 -12)" })));
export const checkboxIndeterminateIcon = (React.createElement(SvgIcon, { viewBox: "0 0 24 24" },
    React.createElement("rect", { x: "3", y: "3", width: "18", height: "18", rx: "5", fill: "currentColor" }),
    React.createElement("rect", { x: "7.5", y: "11", width: "9", height: "2", rx: "1", fill: "#fff" })));
